//import Flickity from 'flickity';

export default {
  init() {
    // JavaScript to be fired on the home page

    /* eslint-disable */

	/* eslint-enable */

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
		
	/* eslint-disable */

    $(document).ready(function(){

		

    });



    /* eslint-enable */
  },
};


// WEBPACK FOOTER //
// ./scripts/routes/home.js